import http from './httpRequest'
import axios from 'axios'

// 免登录的http实例
const publicHttp = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 1000 * 30,
  withCredentials: false
})

publicHttp.interceptors.response.use(response => {
  if (response.data.code == 200) {
    return response.data.data;
  }
  return Promise.reject(response.data)
}, error => {
  return Promise.reject(error)
})

export default {
  getCreatorList(limit = 10, noAuth = false) {
    const httpClient = noAuth ? publicHttp : http
    return httpClient({
      method: 'get',
      url: '/creator/list',
      params: { limit }
    })
  },
  getAgentPlaza(limit = 50, noAuth = false) {
    const httpClient = noAuth ? publicHttp : http
    return httpClient({
      method: 'get',
      url: '/creator/agents',
      params: { limit }
    })
  },
  getAgentsByTag(noAuth = false) {
    const httpClient = noAuth ? publicHttp : http
    return httpClient({
      method: 'get',
      url: '/creator/agents-by-tag'
    })
  }
}
